import React from "react";
import CustomSegmentation from "../../assets/images/list-building/custom-segmentation.png";
import DataEnrichment from "../../assets/images/list-building/data-enrichment.png";
import SmartFilters from "../../assets/images/list-building/smartFilters.png";
import EasyIntegrations from "../../assets/images/list-building/easyIntegrations.png";

const featuresList = [
  {
    img: CustomSegmentation,
    alt: "Custom Segmentation",
    title: "Custom Segmentation",
    desc: "Tailor your lists based on specific demographics, behaviors, and interests to maximize the effectiveness of your campaigns.",
  },
  {
    img: DataEnrichment,
    alt: "Data Enrichment",
    title: "Data Enrichment",
    desc: "Integrate with third-party data sources to enhance the quality of your lists, ensuring you have the most accurate and up-to-date information.",
  },
  {
    img: SmartFilters,
    alt: "Smart Filters",
    title: "Smart Filters",
    desc: "Use advanced filtering options to narrow down your prospects and focus on leads with the highest conversion potential.",
  },
  {
    img: EasyIntegrations,
    alt: "Easy Integration",
    title: "Easy Integration",
    desc: "Seamlessly integrate your lists with your CRM and marketing automation tools, streamlining your workflow and ensuring consistency across platforms.",
  },
];

const FeatureGrid = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Your Target, Our Precision
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Comprehensive List Building Features
          </h2>
        </div>

        {/* 2x2 Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          {featuresList.map((item, idx) => (
            <div
              key={idx}
              className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
                {item.desc}
              </p>

              {/* Showcase Image container */}
              <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeatureGrid;
